export const projectRunBusy = status => ['queued', 'running', 'waiting_plan', 'paused_plan', 'waiting_input', 'waiting_approval'].includes(status)
export const projectVisibleGate = run => ['waiting_input', 'waiting_approval'].includes(run?.status) ? run.gate || null : null
// 两次挂起可能在一次轮询之间完成恢复，比较文档ID而非只比较waiting状态。
export const projectArtifactGateChanged = (before, after) => after?.gate?.kind === 'artifact'
  && (before?.status !== after.status || before?.gate?.artifactJobId !== after.gate.artifactJobId)
export function updateProjectTaskStatus(tasks, task) {
  const status = task.runs.find(run => run.runGuid === task.latestRunGuid)?.status
  return tasks.map(item => item.taskGuid === task.taskGuid ? { ...item, status } : item)
}
export function mergeProjectEvents(existing, incoming) {
  const byId = new Map(existing.map(event => [event.seq, event]))
  for (const event of incoming) if (Number.isInteger(event.seq) && !byId.has(event.seq)) byId.set(event.seq, event)
  return [...byId.values()].sort((a, b) => a.seq - b.seq)
}
export function buildProjectSend(draft) {
  const content = String(draft.content || '').trim()
  if (!content || content.length > 20000) throw new Error('请输入任务目标（不超过20000字）')
  return { projectGuid: draft.projectGuid, ...(draft.taskGuid ? { taskGuid: draft.taskGuid } : {}),
    clientRequestId: draft.clientRequestId, content, planFirst: draft.planFirst === true,
    assetRefs: (draft.assetRefs || []).map(ref => ({ assetGuid: ref.assetGuid, version: ref.version })) }
}

/** 安全门禁拒绝假完成时解释下一步，不能将待审批或模型口头声明展示成真实交付。 */
export function projectTaskFailureLabel(code) {
  return {
    project_plan_declined: '计划未获批准，本轮未继续执行；可以修改要求后重新发起。',
    project_plan_approval_required: '模型未完成真实计划审批，本轮已停止；请更换支持工具调用的模型后重新发起。',
    project_member_delivery_required: '员工尚未提交完整的实际成果，本轮未交付；请检查模型的工具调用能力后重试。',
    project_tool_call_not_executed: '模型只描述了工具调用但未实际执行，本轮未交付；请更换兼容模型后重试。',
    project_config_changed: '项目配置已变更，请重新发起任务',
    project_member_changed: '员工配置已变更，请重新保存项目配置',
    project_model_unavailable: '模型已停用，请更新项目模型',
    project_execution_failed: '本轮执行失败，已保存的草稿仍可使用',
    project_media_quote_changed: '媒体价格或会员权益已变化，请重新确认报价后生成',
    project_media_quote_expired: '媒体报价已过期，请重新提出生成需求',
    project_media_generation_failed: '媒体生成未完成，请查看原作品订单；不会重复下单，扣退沿用原功能规则',
    project_media_vendor_balance_insufficient: '数字人厂商余额不足，请联系管理员补充蝉镜余额；实际退点以原订单记录为准',
    project_media_delivery_required: '媒体仍待确认或生成，本轮不能冒充已交付',
  }[code] || `本轮未完成（${code}），请调整配置或重试。`
}
